export default __webpack_public_path__ + "static/media/f_senses.0f906653.svg";